import { Box } from "@chakra-ui/react";
import { useMemo } from "react";

import { useGetCorrespondents } from "../../api/useGetCorrespondents";
import MultiSelectField from "../MultiSelectInputs";

const CorrCodeSelect = () => {
  const { data: correspondents, isError } = useGetCorrespondents();
  const sortedCorrespondentsOptions = useMemo(() => {
    const sorted =
      correspondents
        ?.sort((a, b) => a.code.localeCompare(b.code))
        .map(corr => ({ label: corr.code, value: corr.code })) || [];

    return sorted.reduce((acc: { [key: string]: string }, val) => {
      acc[val.value] = val.value;
      return acc;
    }, {});
  }, [correspondents]);

  return (
    <Box data-testid="corr-code-select">
      <MultiSelectField
        collapseInput
        allowCustomInput={isError}
        label="Corr. Code"
        testId="corr-code"
        name="correspondentCode"
        options={sortedCorrespondentsOptions}
        optionsConfig={{ keyFormatting: "UPPERCASE" }}
      />
    </Box>
  );
};

export default CorrCodeSelect;
